import type { Edge, Node } from '@xyflow/react';
import type {
  AttackPathEventEdgeData,
  AttackPathEventNodeData,
} from './attack-path-event-node.types';

export const resolveCampaignHoverBrightNodeIds = ({
  campaignId,
  nodes,
  edges,
}: {
  campaignId: string;
  nodes: ReadonlyArray<Node<AttackPathEventNodeData>>;
  edges: ReadonlyArray<Edge<AttackPathEventEdgeData>>;
}): Set<string> => {
  const brightNodeIds = new Set<string>();

  for (const node of nodes) {
    if (node.data.campaignId === campaignId) {
      brightNodeIds.add(node.id);
    }
  }

  for (const edge of edges) {
    if (edge.data?.campaignId !== campaignId) {
      continue;
    }

    brightNodeIds.add(edge.source);
    brightNodeIds.add(edge.target);
  }

  return brightNodeIds;
};
